import React from 'react';
import pagination from 'pagination-logic';
import classNames from 'classnames';
import { RESULTS_PER_PAGE } from '../constants';

import { fireTag } from '../libs/analytics';

const Pagination = ({ total, handleEvent, currentPage, show}) => {

    const paginationResult = pagination({
        total,
        single: RESULTS_PER_PAGE,
        pageSize: 5,
        currentPage,
        pageLinkRule: pageNum => `${pageNum}`,
    });

    const pageLinks = paginationResult.pages;
    const numOfLinks = pageLinks.length;

    pageLinks[0] = paginationResult.firstPage;
    pageLinks[numOfLinks - 1] = paginationResult.lastPage;

    // Probably a better way to set the first and last page as active when selected
	if(typeof currentPage !== typeof pageLinks[0].number){
		// eslint-disable-next-line no-alert
		alert('check pagination js 25');
	}
	if (currentPage === pageLinks[0].number) pageLinks[0].isActive = true;
    if (currentPage === pageLinks[numOfLinks - 1].number) pageLinks[numOfLinks - 1].isActive = true;

    // For the middle results, we need to just take the currentPage and the 2 before and after
    // and add those to the array
    if (paginationResult.currentPage >= 4 && paginationResult.currentPage <= (paginationResult.pageCount - 3)) {
        pageLinks[1] = paginationResult.previousPage;
        pageLinks[2] = {number: currentPage, link: currentPage, isActive: true}
        pageLinks[3] = paginationResult.nextPage;
        pageLinks[0].isEllipsis = true;
        pageLinks[numOfLinks - 1].isEllipsis = true;
    }

    return (
        <div
            className={classNames('pagination' , {
                show,
            })}
        >
            {pageLinks.map((page, i) => {
                let Tag;
                let event;

                if (page.isActive) {
                    Tag = 'span';
                    event = null;
                } else {
                    Tag = 'a';
                    event = () => {
                        fireTag('C5',page.number);
                        handleEvent({
                            action: 'showMore',
                            type: page.number,
                            name: 'results',
                        });
                    };
                }

                const isLastPage = i >= pageLinks.length-1;
                const isFirstPage = i === 0;

                return (
                    <span key={page.number} className="page-number">
                        {isLastPage && (page.isEllipsis && <span className="ellipsis">&hellip;&nbsp;</span>)}
                        <Tag onClick={event} href="#">
                            {page.number}
                        </Tag>
                        {isFirstPage && (page.isEllipsis && <span className="ellipsis">&hellip;</span>)}
                    </span>
                );
            })}
        </div>
    );
};

export default Pagination;
